import React from "react";

const renderIcon = (iconName) => {
  if (iconName === "antenna") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2L8 6M12 2L16 6M12 2v8" />
        <circle cx="12" cy="14" r="2" />
        <path d="M4 20a8 8 0 0016 0" />
      </svg>
    );
  }

  if (iconName === "high-gain") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2v4M8 4l4 4 4-4M5 9h14M3 13h18M5 17h14M7 21h10" />
      </svg>
    );
  }

  if (iconName === "microwave") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="8" width="18" height="8" rx="2" />
        <path d="M7 8V5M12 8V3M17 8V5M7 16v3M12 16v4M17 16v3" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 8h5a3 3 0 013 3v2a3 3 0 003 3h5" />
      <path d="M4 16h5a3 3 0 003-3v-2a3 3 0 013-3h5" />
      <circle cx="4" cy="8" r="1.5" />
      <circle cx="4" cy="16" r="1.5" />
      <circle cx="20" cy="8" r="1.5" />
      <circle cx="20" cy="16" r="1.5" />
    </svg>
  );
};

function Products({ onBrowseFamily, content }) {
  const products = content?.cards || [];

  return (
    <section className="products-section" id="products">
      <div className="section-wrap">
        <div className="products-header">
          <div>
            <div className="section-eyebrow">{content?.eyebrow}</div>
            <h2 className="section-title">{content?.title}</h2>
            <p className="section-sub">{content?.subtitle}</p>
          </div>
          <a href={`#${content?.linkTarget || "categories"}`} className="btn-secondary products-link">
            {content?.linkLabel} <span aria-hidden="true">-></span>
          </a>
        </div>
        <div className="products-grid">
          {products.map((product) => (
            <div
              className="product-card"
              key={product.title}
              role="button"
              tabIndex={0}
              onClick={() => onBrowseFamily?.(product.menuTitle)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onBrowseFamily?.(product.menuTitle);
                }
              }}
            >
              <div className="product-card-num">{product.num}</div>
              <div className="product-icon-wrap">{renderIcon(product.icon)}</div>
              <h3>{product.title}</h3>
              <p>{product.description}</p>
              <div className="product-tags">
                {(product.tags || []).map((tag) => (
                  <span className="tag" key={tag}>
                    {tag}
                  </span>
                ))}
              </div>
              <button
                type="button"
                className="product-card-link"
                onClick={(event) => {
                  event.stopPropagation();
                  onBrowseFamily?.(product.menuTitle);
                }}
              >
                Browse Products <span aria-hidden="true">-></span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;
